import { FiDownload, FiShare } from 'react-icons/fi';

import { useApp } from '@/contexts/AppContext';

import { BottomBanner } from './BottomBanner';
import { usePWAInstall } from './usePWAInstall';

export function PWAInstallBanner() {
  const { canInstall, isIOSDevice, promptInstall, dismiss } = usePWAInstall();
  const { app } = useApp();

  // Página pública da captura por QR: o cliente final NÃO deve ser convidado a
  // instalar o PWA do tenant (spec §4.8). O banner é montado fora do Router
  // (main.tsx), então o guard é pelo pathname.
  if (window.location.pathname.startsWith('/leads/capture/')) return null;

  if (!canInstall && !isIOSDevice) return null;

  const appName = app?.name || 'o aplicativo';

  return (
    <BottomBanner
      testId="pwa-install-banner"
      title={<>Instale {appName}</>}
      description={
        isIOSDevice
          ? <>Toque em <FiShare style={{ display: 'inline', verticalAlign: 'middle' }} size={14} /> e depois &quot;Adicionar à Tela de Início&quot;</>
          : 'Acesso rápido direto da tela inicial'
      }
      {...(canInstall
        ? {
            actionLabel: 'Instalar',
            actionIcon: <FiDownload size={14} />,
            onAction: promptInstall,
          }
        : {})}
      onDismiss={dismiss}
    />
  );
}
